export const SET_REPOSITORY_USER_USAGE_PAGE_INDEX = '@repository/SET_REPOSITORY_USER_USAGE_PAGE_INDEX';
export const SET_REPOSITORY_USER_USAGE_SORT_BY = '@repository/SET_REPOSITORY_USER_USAGE_SORT_BY';
export const SET_REPOSITORY_USER_USAGE_SORT_TYPE = '@repository/SET_REPOSITORY_USER_USAGE_SORT_TYPE';

export const FETCH_REPOSITORY_USER_USAGE_REQUEST = '@repository/FETCH_REPOSITORY_USER_USAGE_REQUEST';
export const FETCH_REPOSITORY_USER_USAGE_SUCCESS = '@repository/FETCH_REPOSITORY_USER_USAGE_SUCCESS';
export const FETCH_REPOSITORY_USER_USAGE_FAILED = '@repository/FETCH_REPOSITORY_USER_USAGE_FAILED';
